import React from 'react';

const StickyTip = () => {
  return <div className="sticky-tip">
    <p className="sticky-tip-text">Scroll down and read the information below. Choose “Get Started” when you are ready to continue.</p>
  </div>
}

export default StickyTip;
